import { render, staticRenderFns } from "./MEM912P01.vue?vue&type=template&id=128ef39e&"
import script from "./MEM912P01.vue?vue&type=script&lang=js&"
export * from "./MEM912P01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports